import { MutableValue } from "@/modules/api/mutable-value.interface";
import { ProductValue } from "@/modules/plushie/product.value";

export default class LabelHeaderProductRelation implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fHeader: string,
    private fProduct: ProductValue
  ) {
    [fId, fHeader, fProduct].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get header(): string {
    return this.fHeader;
  }

  get product(): ProductValue {
    return this.fProduct;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
